import { Router } from '@angular/router';
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { HomeComponent } from 'app/pages/home/home.component';

@Component({
  selector: 'app-barra-navegacao',
  templateUrl: './barra-navegacao.component.html',
  styleUrls: ['./barra-navegacao.component.sass']
})
export class BarraNavegacaoComponent implements OnInit {
  @Input() caminhos: string[];

  constructor(private route: Router) { }

  ngOnInit(): void {
  }

  irParaHome() {
    this.route.navigate(['home']); 
  }

}
